import React, { useState } from 'react'
import { X, ChevronRight } from 'lucide-react'
import axios from 'axios'
import { BASE_URL } from 'utils/constant'
import FieldOfWork from '../../Project Dashboard/Workers/PaymentDetailsForm'

const NewContractor = ({ onClose, onSave }) => {
  const [name, setName] = useState('')
  const [worknameId, setWorknameId] = useState('')
  const [fieldOfWorkName, setFieldOfWorkName] = useState('')
  const [contact, setContact] = useState('')
  const [address, setAddress] = useState('')
  const [saving, setSaving] = useState(false)
  const [errors, setErrors] = useState({})
  const [view, setView] = useState('form') // 'form' | 'fieldOfWork'

  const handleContactChange = (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, '').slice(0, 10)
    setContact(onlyNums)
  }

  const validate = () => {
    const nextErrors = {}
    if (!name.trim()) nextErrors.name = 'Name is required'
    if (!worknameId) nextErrors.fieldOfWork = 'Field of work is required'
    if (!/^[0-9]{10}$/.test(contact)) nextErrors.contact = 'Valid 10-digit contact is required'
    setErrors(nextErrors)
    return Object.keys(nextErrors).length === 0
  }

  const handleSave = async () => {
    if (saving) return
    if (!validate()) return
    try {
      setSaving(true)
      const orgId = JSON.parse(localStorage.getItem('organization'))?.id
      const payload = {
        organization: Number(orgId),
        name: name.trim(),
        workname_id: Number(worknameId),
        contact: `+91${contact}`,
        address: address.trim()
      }
      const token = localStorage.getItem('access')
      const res = await axios.post(`${BASE_URL}/org/contractors/create/`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (res?.data) {
        if (typeof onSave === 'function') onSave(res.data.data)
        onClose()
      } else {
        setErrors({ submit: res?.data?.message || 'Failed to create contractor' })
      }
    } catch (e) {
      setErrors({ submit: 'Failed to create contractor. Please try again.' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50">
      <div className="bg-white rounded-[15px] w-[720px] relative shadow-xl overflow-hidden">
        <div className="bg-white">
          <div className="flex items-center justify-between px-5 py-4 border-b">
            <h2 className="text-[#232323] text-[18px] font-semibold">Create Contractor</h2>
            <button aria-label="Close" className="text-gray-600 hover:text-black" onClick={onClose}>
              <X />
            </button>
          </div>

          <div className="px-5 py-6">
            {view === 'fieldOfWork' ? (
              <FieldOfWork
                onSelect={(field) => {
                  setWorknameId(String(field.id))
                  setFieldOfWorkName(field.name)
                  setErrors((prev) => ({ ...prev, fieldOfWork: undefined }))
                  setView('form')
                }}
                onClose={() => setView('form')}
              />
            ) : (
              <>
                <div className="mb-4">
                  <div className="text-[#232323] text-[16px] font-bold">General Details</div>
                </div>

                <div className="space-y-5">
                  {errors.submit && (
                    <div className="p-2 bg-red-100 text-red-700 rounded text-[14px]">{errors.submit}</div>
                  )}
                  <div>
                    <label className="block text-[#000000] text-[14px] mb-1 font-medium">Contractor Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter Name"
                      className={`w-full px-3 py-2 text-[16px] rounded-lg bg-[#F3F4F6] outline-none ${errors.name ? 'border border-red-500' : ''}`}
                    />
                    {errors.name && <p className="text-red-500 text-[12px] mt-1">{errors.name}</p>}
                  </div>

                  <div>
                    <label className="block text-[#000000] text-[14px] mb-1 font-medium">Field of Work</label>
                    <button
                      type="button"
                      onClick={() => setView('fieldOfWork')}
                      className={`mt-1 w-full px-3 py-2 rounded-lg bg-[#F3F4F6] outline-none text-left text-gray-700 flex items-center justify-between ${errors.fieldOfWork ? 'border border-red-500' : ''}`}
                    >
                      <span className="truncate">
                        {fieldOfWorkName || 'Select Field of Work'}
                      </span>
                      <ChevronRight className="h-4 w-4 text-gray-500" />
                    </button>
                    {errors.fieldOfWork && <p className="text-red-500 text-[12px] mt-1">{errors.fieldOfWork}</p>}
                  </div>

                  <div>
                    <label className="block text-[#000000] text-[14px] mb-1 font-medium">Contact number</label>
                    <div className="flex">
                      <span className="inline-flex items-center px-3 py-2 text-sm text-gray-900 bg-[#F3F4F6] rounded-l-md">+91</span>
                      <input
                        type="text"
                        inputMode="numeric"
                        maxLength={10}
                        value={contact}
                        onChange={handleContactChange}
                        placeholder="9999999999"
                        className={`flex-1 bg-[#F3F4F6] rounded-r-md outline-none px-3 py-2 ${errors.contact ? 'border border-red-500' : ''}`}
                      />
                    </div>
                    {errors.contact && <p className="text-red-500 text-[12px] mt-1">{errors.contact}</p>}
                  </div>

                  <div>
                    <label className="block text-[#000000] text-[14px] mb-1 font-medium">Address</label>
                    <input
                      type="text"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Add Address here"
                      className="w-full px-3 py-2 rounded-lg bg-[#F3F4F6] outline-none"
                    />
                  </div>
                </div>

                <div className="flex justify-center mt-8">
                  <button
                    onClick={handleSave}
                    disabled={saving}
                    className="w-56 h-12 bg-[#3B0069] text-[16px] hover:bg-[#2a004c] text-white rounded-md flex items-center justify-center gap-3 disabled:opacity-50"
                  >
                    {saving ? 'Saving...' : 'Save'}
                    <span className="w-8 h-8 rounded-full bg-[#5E2D91] flex items-center justify-center">
                      <ChevronRight className="h-5 w-5 text-white" />
                    </span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewContractor


